import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 9px 28px 8px #0000000d;
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
`;
